export const activitySelectors = {
  getAllActivitiesListData: state => state.activities.allActivities.results,
  hasFetchedActivities: state => state.activities.hasFetchedActivities,
  isActivitiesFetching: state => state.activities.isActivitiesFetching,
};
